import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Feature Request Management Software | Canny';
const Description =
  "Canny's feature request management tools let you collect, organize, and analyze feedback with ease. Create your feature request board today! Start for free!";
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/use-cases/feature-request-management' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
